import {connect} from 'react-redux';
import React, {Component} from 'react';

import mainImg1 from '../../static/img/slides/1.jpg';
import mainImg2 from '../../static/img/slides/2.jpg';
import mainImg3 from '../../static/img/slides/3.jpg';
import mainImg4 from '../../static/img/slides/4.jpg';
import mainImg5 from '../../static/img/slides/5.jpg';
import mainImg6 from '../../static/img/slides/6.jpg';
import mainImg7 from '../../static/img/slides/7.jpg';
import mainImg8 from '../../static/img/slides/8.jpg';
import mainImg9 from '../../static/img/slides/9.jpg';
import mainImg10 from '../../static/img/slides/10.jpg';

class PromoContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            intervalId: -1,
            backgroundImage: mainImg1
        };
    }

    initMainSlider() {

        let current = 0;
        let array = [mainImg1, mainImg2, mainImg3, mainImg4, mainImg5, mainImg6, mainImg7, mainImg8, mainImg9, mainImg10];

        let id = window.setInterval(() => {
            current++;
            if (current === 10) {
                current = 0;
            }
            this.setState({backgroundImage: array[current]});
        }, 8 * 1000);


        this.setState({intervalId: id});

    }

    componentDidMount() {
        // init main slider
        this.initMainSlider();
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    render() {
        const {i18n} = this.props;

        return (
            <div className="promo-content"
                 style={{'backgroundImage': 'url("' + this.state.backgroundImage + '")'}}>
                <div className="promo-title">
                    <h1>
                        {i18n['layout.promoTitleLine1']}<br />{i18n['layout.promoTitleLine2']}
                    </h1>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PromoContent);


// WEBPACK FOOTER //
// ./src/components/Base/PromoContent.js